<template>
    <div class="sustainability-env">
      <div class="sustainability-env-content">
          <p class="indent">Environment protection and the effective use of natural resources have always been among the top priorities in the development of Alcomet. For the past few years, all investments in the modernization and expansion of production capabilities have invariably been accompanied by the installation of modern purification facilities. The technical and technological solutions employed are of the highest level and guarantee a high degree of purification of the air emissions and the water used in production. The company has developed a number of programmes to manage production waste, the greater part of which is delivered for utilization by other industrial sectors.</p>
          <img v-scroll-reveal.reset class="row-img" src="/static/img/sustainability/environment/env.jpg" alt="">

          <p class="indent">The company has developed a number of programmes to
            manage production waste, the greater part of which is delivered
            for utilization by other industrial sectors. The existing melting
            furnaces enable the recycling and reuse of aluminium scrap
            generated in Bulgaria, thus reducing high energy costs and
            limiting the harmful emissions resulting from the production
            of primary aluminium. Consistent with its environmental policy,
            the company has developed and introduced an Integrated
            Management System in compliance with the requirements of EN
            ISO 14001:2015. Through recycling, Alcomet manages not only to
            preserve the natural resources but also to achieve energy saving
            and thus reducing carbon footprint.</p>
        <p class="indent">The company has conducted a Life Cycle Assessment (LCA), which is available and can be provided to all interested parties upon request</p>

        <h2>Aluminium dross</h2>
        <p class="indent">Aluminium dross is formed on the surface of molten aluminium
          as a valuable byproduct of the aluminium smelting process. It can
          be mechanically recycled to recover the aluminium content for the
          secondary aluminium industry.</p>

        <h2>Aluminium scrap</h2>
        <p class="indent">Aluminium scrap generated in the production process is completely
        reused in Alcomet’s foundry. Sheet and coil scrap, as well as scrap
        from extrusion, can be remelted directly in the casting furnaces while
        foil scrap must first be melted into secondary ingots. Alternatively, foil
        scrap can be baled and supplied as a raw material to manufacturers
        of aluminium pigments, powders and flakes.</p>
          <!-- <div class="row">
            <div class="row-text">
              <p class="indent">The existing melting furnaces enable the recycling and reuse of aluminium scrap generated in Bulgaria, thus reducing high energy costs and limiting the harmful emissions resulting from the production of primary aluminium.</p>
              <p class="indent">Consistent with its environmental policy, the company has developed and introduced an Integrated Management System in compliance with the requirements of EN ISO 14001.</p>
            </div>
            <div class="row-img" :style="{ backgroundImage : `url(${'/static/img/sustainability/environment/env.jpg'})` }"></div>
          </div> -->
          <p>
            <a href="/static/files/Alcomet-Environmental-Management-Policy.pdf" target="_blank">Alcomet Environmental Management Policy</a>
          </p>
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-env-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sustainability-env-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.row {
  display: flex;
  margin: 30px auto;
  width: 80%;
}
.row-text {
  margin-right: 20px;
  width: 33.33%;
}
.row-img {
  border-radius: 6px;
  margin: 20px auto;
  min-height: 1px;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-env {
    padding-bottom: 20px;
  }
  .sustainability-env-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .row-img {
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/Environment.vue